export enum Locale {
    "en" = "en",
    "ja" = "ja"
}

export enum NavApiPaths {
    "menu-items" = "menu-items",
    "footer-menu-items" = "footer-menu-items"
}

export enum Breakpoints {
    "desktop" = "desktop",
    "mobile" = "mobile",
    "default" = "default"
}

type AtLeastOneKey<T extends string, V> = Partial<Record<T, V>> & {
    [K in T]: Required<Pick<Record<T, V>, K>>
  }[T];

export type NavCurationConfig = {
    [PathKey in NavApiPaths]: AtLeastOneKey<Breakpoints, string>
}

export const CURATION_PATHS: Record<keyof typeof Locale, NavCurationConfig> = {
    [Locale.en]: {
        [NavApiPaths["menu-items"]]: {
            [Breakpoints.desktop]: "new_navi_1",
            [Breakpoints.mobile]: "new_navi_mobile_1"
        },
        [NavApiPaths["footer-menu-items"]]: {
            [Breakpoints.default]: "new_navi_footer"
        }
    },
    [Locale.ja]: {
        [NavApiPaths["menu-items"]]: {
            [Breakpoints.desktop]: "nav-japan--desktop",
            [Breakpoints.mobile]: "nav-japan--mobile"
        },
        [NavApiPaths["footer-menu-items"]]: {
            [Breakpoints.default]: "nav-japan--footer"
        }
    }
};
